import { render, staticRenderFns } from "./new_trusteeshio_msg.vue?vue&type=template&id=5516b6b3&scoped=true&"
import script from "./new_trusteeshio_msg.vue?vue&type=script&lang=js&"
export * from "./new_trusteeshio_msg.vue?vue&type=script&lang=js&"
import style0 from "./new_trusteeshio_msg.vue?vue&type=style&index=0&id=5516b6b3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5516b6b3",
  null
  
)

export default component.exports